export default __webpack_public_path__ + "static/media/cn-hk.6ef95675.svg";